import React from "react";
const StoryItem = ({ data, setSelectedStory, setOpenModal, index }) => {
  const selectStoryHandler = () => {
    setSelectedStory({ ...data, index });
    setOpenModal(true);
  };

  return (
    <div className="flex flex-col items-center gap-3">
      <button
        onClick={selectStoryHandler}
        className="story-item active:scale-90 transition-all duration-300 w-[90px] p-[2px] h-[90px] rounded-full"
      >
        <img
          src={data.header.profileImage}
          className="rounded-full w-full h-full object-cover object-center border-[3px] border-[#151515]"
          alt=""
        />
      </button>

      <span className="text-sm text-gray-300">{data.header.heading}</span>
    </div>
  );
};

export default StoryItem;
